import EditIcon from "./_EditIcon"
import ControlButtons from "./_ControlButtons"
import { useTableStore } from "../../_stores"
import { useEffect, useRef, useState } from "react"

const Cell = ({
	isEditable = true,
	editDivRef,
	column,
	data,
	setIsDropdownOpen,
	setDropdownData,
	editDivInputHandler,
	isLink = false,
}, ref) => {
	data = data !== undefined && data !== null ? data.toString() : ""
	
	// store
	const onCellDataSave = useTableStore(state => state.onCellDataSave)
	const onCellEdit = useTableStore(state => state.onCellEdit)

	// local
	const [isEditing, setIsEditing] = useState(false)
	const [editable, setEditable] = useState(isEditable)
	const [cellData, setCellData] = useState({})
	const [isEnabled, setIsEnabled] = useState(true)

	if (!editDivRef) editDivRef = useRef(null)
	if (!ref) ref = useRef(null)

	// functions
	const updateData = (data, fireEvent = true, additionalParams = undefined) => {
		if (typeof data === "string") {
			data = data || ""
			data = data.toString()

			data = {
				text: data,
				value: data 
			}
		}

		if (!column.isNullable) {
			if (data.text === undefined && data.value !== undefined){
				data.text = data.value
			} 
	
			if (data.value === undefined && data.text !== undefined){
				data.value = data.text
			}
	
			data.value = data.value.toString() || ""
			data.text = setIsDropdownOpen ? column.dropdownData.find(item => item.value.toString() === data.value)?.text : data.text
		} else {
			if (data === null) {
				data = {
					text: "",
					value: ""
				}
			}
		}

		setCellData((prev) => {
			fireEvent &&
				onCellDataSave?.({
					row: ref.current.closest('tr'),
					column: column,
					cell: ref.current,
					previousData: prev,
					newData: data,
					additionalParams: additionalParams,
				})

			return data
		})
	}
	

	const handleIconClick = () => {
		setIsEditing(true)
	}

	const handleDoubleClick = (e) => {
		if (editable) {
			// check for double click
			if (e.detail === 2 && !isEditing) {
				setIsEditing(true)
				e.stopPropagation()
			}
		}
	}

	const handleButtonClick = () => {
		setIsEditing(false)
	}

	useEffect(() => {
		// expose the method through the ref
		ref.current.updateData = updateData
		ref.current.getData = () => cellData
		ref.current.setActive = setIsEnabled
		ref.current.setDropdownData = setDropdownData
		ref.current.setIsEditing = setIsEditing
		ref.current.setEditable = setEditable
	}, [ref.current, cellData, setIsEnabled, setDropdownData, setIsEditing, setEditable])

	useEffect(() => {
		if (isEditing) {
			onCellEdit?.({
				row: ref.current.closest('tr'),
				column: column,
				cell: ref.current,
			})

			editDivRef.current.focus()

			if (setIsDropdownOpen) {
				editDivRef.current.textContent = ""
				setIsDropdownOpen(true)
			} else {
				editDivRef.current.textContent = cellData.text
			}
		}

	}, [isEditing])

	useEffect(() => {
		setCellData({
			text: setIsDropdownOpen ? column.dropdownData.find(item => item.value.toString() === data)?.text : data,
			value: data
		})
	}, [data])

	return (
		<td className={`group/edit-content ${isEditing ? '!px-2 !py-2.5' : editable ? '!pr-1' : ''} ${editable && !isEditing ? 'transition-all hover:cursor-pointer hover:text-primary' : ''}`} hidden={!column.isVisible} data-header={column.heading} ref={ref} disabled={!isEnabled} data-index={column.index} data-text={ isEditable &&  cellData.text } onClick={handleDoubleClick}
		data-value={isEditable && cellData.value}
		>
			{!isEditing && (
				// render a normal cell
				<div className="flex items-start gap-2">
					{isLink ? (
						<a href={cellData.text} className="grow" target="_blank" rel="noreferrer">
							{cellData.text}
						</a>
					) : <div className="grow" dangerouslySetInnerHTML={{ __html: cellData.text }}></div>}

					{
						editable &&
						<EditIcon
							onClick={handleIconClick}
						/>
					}
				</div>
			)}

			{isEditing && (
				// render an editable cell
				<div className="flex flex-col gap-2">
					{
						setIsDropdownOpen && (
							<div ref={editDivRef} contentEditable="true" placeholder={cellData.text}
								onFocus={() => setIsDropdownOpen(true)} onInput={editDivInputHandler}
								className="
									grow py-2.5 px-[7px] border-grey border-thin rounded-primary outline-none
									[&[placeholder]:empty:before]:content-[attr(placeholder)] [&[placeholder]:empty:before]:text-placeholderGray">

							</div>
						)
					}{
						!setIsDropdownOpen && (
							<div ref={editDivRef} contentEditable="true" placeholder={cellData.text} data-value={cellData.value}
								className="
									grow py-2.5 px-[7px] border-grey border-thin rounded-primary outline-none
									[&[placeholder]:empty:before]:content-[attr(placeholder)] [&[placeholder]:empty:before]:text-placeholderGray">
							</div>
						)
					}
					<ControlButtons
						saveButtonClick={() => {
							updateData(setIsDropdownOpen ? ({
								text: editDivRef.current.getAttribute('placeholder'),
								value: editDivRef.current.getAttribute('data-value')
							}): editDivRef.current.textContent)
							handleButtonClick()
						}}
						cancelButtonClick={handleButtonClick} />
				</div>
			)}
		</td>
	)
}

export default React.forwardRef(Cell)